import React, { useState } from "react";
import { Button, Form, Input, InputNumber, message, Modal, Popconfirm, Space, Table } from "antd";
import { useQuery } from "react-query";
import jwtAxios from "../../../../auth/jwt-api";
import translate from "../../../../i18n/translate";
import { FaPlus } from "react-icons/fa";
import { DeleteOutlined } from "@ant-design/icons";

export default function DollarRate() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const { data, isLoading, refetch } = useQuery(
    "/dollar-rate",
    () => jwtAxios.get("/dollar-rate")
  );

  const handleAdd = () => {
    form.resetFields();
    setIsModalOpen(true);
  };



  const handleDelete = async (id) => {
    try {
      await jwtAxios.delete(`/dollar-rate/${id}`);
      refetch();
    } catch (error) {
      message.error(error.response?.data?.error || translate("message.error.delete"));
    }
  };

  const handleSubmit = async (values) => {
    setLoading(true);
    try {

        await jwtAxios.post("/dollar-rate", values);
      setIsModalOpen(false);
      form.resetFields();
      refetch();
    } catch (error) {
      message.error(error.response?.data?.error || translate("message.error.occurred"));
    }
    setLoading(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    form.resetFields();
  };

  const columns = [
    {
      title: "№",
      dataIndex: "id",
      key: "id",
      width: 80,
      render: (_, __, index) => index + 1,
    },
    {
      title: translate("dollar_rate.rate"),
      dataIndex: "rate",
      key: "rate",
      render: (rate) => rate?.toLocaleString() + " UZS",
    },
    {
      title: translate("table.column.actions"),
      key: "actions",
      width: 120,
      render: (_, record) => (
        <Space>

          <Popconfirm
            title={translate("message.confirm.delete")}
            onConfirm={() => handleDelete(record.id)}
            okText={translate("common.yes")}
            cancelText={translate("common.no")}
          >
            <Button danger icon={<DeleteOutlined />} />
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <div style={{ padding: "clamp(10px,3%,30px)" }}>
      <h1>{translate("common.sidebar.dollar_rate")}</h1>
      <br />
      <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 16 }}>
        <Button type="primary" icon={<FaPlus />} onClick={handleAdd}>
          {translate("button.add")}
        </Button>
      </div>
      <Table
        loading={isLoading}
        columns={columns}
        dataSource={data?.data?.data?.results?.rows || data?.data?.data || []}
        rowKey="id"
        pagination={{ pageSize: 10 }}
      />

      <Modal
        title={translate("dollar_rate.add")}
        open={isModalOpen}
        onCancel={handleCancel}
        footer={null}
        centered
      >
        <br />
        <Form form={form}
              initialValues={{ rate: null }}
              layout="vertical" onFinish={handleSubmit}>
          <Form.Item
            label={translate("dollar_rate.rate")}
            name="rate"
            rules={[
              {
                required: true,
                message: translate("form.error.rate_required"),
              },
            ]}
          >
            <InputNumber
              style={{ width: "100%" }}
              addonAfter="UZS"
              min={0}
              formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, " ")}

            />
          </Form.Item>
          <Form.Item style={{ marginBottom: 0, textAlign: "right" }}>
            <Space>
              <Button onClick={handleCancel}>{translate("button.cancel")}</Button>
              <Button type="primary" htmlType="submit" loading={loading}>
                {translate("button.submit")}
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
}
